import {Input, Spinner} from 'reactstrap'
import InfiniteScroll from 'react-infinite-scroll-component'
import React, {useEffect, useState, useCallback, useRef} from 'react'
import {ReactComponent as SearchIcon} from '../../../../../assets/icons/search.svg'
import {getMerchizeCollections, getMerchizeLibrary} from '../../../../../services/MerchizeLibraryServices'
import {toaster} from '../../../../../shared/PFToast'
import {debounce} from 'lodash'
import randomstring from 'randomstring'
import {actionAddImageLayer, actionChangeTabDesign} from '../../../context/SelectedVariantContext/action'
import {useSelectedVariantContext} from '../../../context/SelectedVariantContext'

const PopupLibrary = () => {
    const [libraries, setLibraries] = React.useState([])
    const [collections, setCollections] = React.useState([])
    const [loading, setLoading] = React.useState(false)
    const [loadingPaging, setLoadingPaging] = React.useState(false)
    const [page, setPage] = useState(1);
    const [total, setTotal] = useState(0);
    const [pages, setPages] = React.useState(1)
    const [search, setSearch] = useState('')
    const [filters, setFilters] = React.useState({sort: "desc", collections: []})
    const [hasMore, setHasMore] = useState(true);
    const {dispatch} = useSelectedVariantContext()
    const collectionsRef = useRef(null);

    const getWindowHeight = () => {
        const {innerHeight: height} = window
        return height
    }
    const [windowHeight, setWindowHeight] = useState(getWindowHeight())

    const handleWheel = (e) => {
        e.preventDefault();
        collectionsRef.current.scrollLeft += e.deltaY;
    };

    const debouncedChangeSearch = useCallback(
        debounce((value) => {
            setFilters((prev) => ({
                ...prev,
                alt_text: value,
            }))
            setPage(1)
            setHasMore(true)
        }, 500),
        []
    )

    const _handleChange = e => {
        const {value} = e.target

        setSearch(value)
        debouncedChangeSearch(value)
    }

    const _handleChangeSelect = (event) => {
        const value = event.target.value
        setFilters({...filters, collections: !!value ? [value] : []})
        setPage(1)
        setHasMore(true)
    }

    const _fetchLibraries = async () => {
        try {
            setLoading(true)
            const {...res} = Object.assign({}, filters)
            const params = {
                ...res,
                display_on_mockup_generator: true
            }
            const {data, success, message} = await getMerchizeLibrary(params)
            if (!success) {
                toaster({
                    type: 'error',
                    message
                })
            }
            const {items, total, totalPage} = data
            setTotal(total);
            setLibraries(items)
            setPages(totalPage)
            setHasMore(page < totalPage)
        } catch (error) {
            console.error('Error fetching libraries:', error)
        } finally {
            setLoading(false)
        }
    }

    const _fetchCollections = async () => {
        try {
            const {data, success, message} = await getMerchizeCollections()
            if (!success) {
                toaster({
                    type: 'error',
                    message
                })
            }
            setCollections(data)
        } catch (error) {
            console.error('Error fetching collection:', error)
        }
    }

    const _onSelectCollection = (collection) => {
        const imageObj = {
            name: collection.title || '',
            _id: randomstring.generate(7),
            src: collection.image_s3_url || '',
            tinySrc: collection.image_s3_thumbnail_url || '',
            naturalSize: collection.image_size || '',
            imageType: collection.image_type,
            naturalWidth: collection.image_width,
            naturalHeight: collection.image_height,
            created: collection.created,
        }
        dispatch(actionAddImageLayer(imageObj))
        dispatch(actionChangeTabDesign(''))
    }

    const _next = async () => {
        const newPage = page + 1
        try {
            if (newPage > pages) return setHasMore(false)
            const {success, data, message} = await getMerchizeLibrary({...filters, display_on_mockup_generator: true, page: newPage})
            if (!success) throw new Error(message)
            const {items, totalPage: responsePages} = data
            setPages(responsePages)
            setLibraries([...libraries, ...items])
        } catch (error) {
            toaster({
                type: 'error',
                message: error.message,
            })
        } finally {
            setPage(newPage)
        }
    }

    useEffect(() => {
        _fetchCollections()
    }, [])

    useEffect(() => {
        console.log(222222)
        _fetchLibraries()
    }, [filters])

    useEffect(() => {
        const handleResize = () => {
            setWindowHeight(getWindowHeight())
        }

        window.addEventListener('resize', handleResize)
        return () => window.removeEventListener('resize', handleResize)
    }, [])

    return <div className="PopupLibraryContainer">
        <div className="PopupLibrary">
            <div className="PopupLibraryHeader">
                <h2>AI library</h2>
            </div>
            <div className="PopupLibraryFilters">
                <div className="FilterText">
                    <Input
                        autoComplete="off"
                        type="text"
                        // name={name}
                        value={search}
                        placeholder="Search library..."
                        className="form-control"
                        onChange={_handleChange}
                    />
                    <SearchIcon/>
                </div>
                <div className="FilterSelect">
                    <Input
                        id="collections"
                        name="collections"
                        type="select"
                        onChange={_handleChangeSelect}
                    >
                        <option value="">
                            All library
                        </option>
                        {
                            collections.length > 0 && (
                                collections.map((collection, index) => {
                                    return (
                                        <option value={collection._id}>
                                            {collection.name}
                                        </option>
                                    )
                                })
                            )
                        }
                    </Input>
                </div>
            </div>
            <div className="PopupLibraryContent">
                {loading ? <Loading /> : libraries.length > 0 && (
                    <InfiniteScroll
                        next={_next}
                        hasMore={hasMore}
                        className='ListImages'
                        loader={<Loading />}
                        dataLength={libraries.length}
                        height={windowHeight - 296 < (libraries.length % 2 === 0 ? libraries.length / 2 : Math.floor(libraries.length / 2) + 1)*200 ? windowHeight - 296 : null}
                    >
                        {libraries.map((library, index) => {
                            return <div className='ImageBox' onClick={() => _onSelectCollection(library)}>
                                <div className={`ImageWrapper ${library.alt_text.includes('pattern') ? 'pattern' : ''}`}>
                                    <img src={library.image_s3_thumbnail_url || ''}
                                         alt={library.alt_text || ''} />
                                </div>
                                <div className='ImageInfo'>
                                    {library.image_width}px x {library.image_height}px
                                </div>
                            </div>
                        })}
                    </InfiniteScroll>
                )}
            </div>
        </div>
    </div>
}

const Loading = () => {
    return (
        <div className="LoadingScroll">
            <Spinner style={{color: '#007bff'}} />
        </div>
    )
}

export default PopupLibrary